import React from 'react';
import { useSearchContext } from '@/context';
import { cn } from '@/utils';

export interface DidYouMeanProps {
  onDidYouMeanClick: () => void;
  onDidYouMeanEnter: (event: React.KeyboardEvent<HTMLElement>) => void;
  didYouMeanText: string;
  className?: string;
}

export const DidYouMean = ({ onDidYouMeanClick, onDidYouMeanEnter, didYouMeanText, className }: DidYouMeanProps) => {
  return (
    <p className={cn('font-proxima text-lg font-normal leading-7 text-black', className)}>
      Did you mean{' '}
      <span
        className="cursor-pointer font-bold italic underline"
        onClick={onDidYouMeanClick}
        onKeyUp={onDidYouMeanEnter}
        tabIndex={0}
      >
        {didYouMeanText}
      </span>
      ?
    </p>
  );
};

export const DidYouMeanPanel = () => {
  const { searchResults, setSearchAndSuggestionQuery } = useSearchContext();
  if (searchResults?.didYouMean) {
    const onDidYouMeanClick = () => {
      setSearchAndSuggestionQuery(searchResults.didYouMean!);
    };

    const onDidYouMeanEnter = (event: React.KeyboardEvent<HTMLElement>) => {
      if (event.code === 'Enter') {
        onDidYouMeanClick();
      }
    };

    return (
      <DidYouMean
        onDidYouMeanClick={onDidYouMeanClick}
        onDidYouMeanEnter={onDidYouMeanEnter}
        didYouMeanText={searchResults.didYouMean}
      />
    );
  }
  return '';
};
